import React from "react";

const Card = ({title, image, bg_color, title_color, description, description_color}) => {
    return(
        <div style={{backgroundColor:`${bg_color}`}} className={`p-6 w-full h-full bg-[${bg_color}] rounded-2xl overflow-hidden relative group flex flex-col`}>
            <img src={image} alt="icon" className="w-[42px] h-[42px] xs:mb-6 mb-8"/>
            <span style={{color: `${title_color}`}} className={`text-[18px] lg:text-[20px] xs:mb-4 mb-3`}>
            {title}
            </span>
            <span style={{color: `${description_color}`}} className={`text-[14px] lg:text-[14px] `}>
            {description}
            </span>
              
        </div>
    );
};

export default Card;